import { useParams } from "react-router-dom";
import { getOneArtist } from "../../api-route/artist";
import Artist from "../../Components/artists-section/Artist";
import HeroHeader from "../../Components/hero-header-section/index.section";
import { useEffect, useRef, useState } from "react";

const Index = () => {
    const { slug } = useParams()
    const [currentpage, setCurrentpage] = useState(1)
    const pagination = useRef()

    const [artist, setArtist] = useState()
    const [painting, setPainting] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    useEffect(() => {
        const get = async () => {
            if (!slug) return; // Ensure `slug` is defined

            try {
                const data = await getOneArtist(slug, { page: currentpage });
                if (data) {
                    const { paintings, ...other } = data || {}
                    setPainting(data ? paintings.data : [])
                    setArtist(other)
                    pagination.current = data ? Math.ceil(data.paintings.total / data.paintings.per_page) : 1
                } else {
                    setError("هنرمند پیدا نشد");
                }
            } catch (err) {
                setError("مشکل در بارگزاری اطلاعات");
            } finally {
                setLoading(false);
            }
        }
        get()
    }, [slug, currentpage]);

    if (loading) {
        return <div className="centerOfParent h-screen w-full">درحال‌بارگذاری</div>;
    }

    if (error) {
        return <div className="centerOfParent h-screen w-full">{error}</div>;
    }

    if (!artist) {
        return <div className="centerOfParent h-screen w-full">اطلاعات هنرمند پیدا نشد</div>;
    }

    return (
        <>
            {!!artist ? <main className="flex flex-col">
                <HeroHeader {...artist} breadcrumb={[{ slug: 'artists', name: 'هنرمندان' }, { name: artist.persian_title || artist.title }]} />
                <Artist {...{ currentpage, setCurrentpage, artist, painting, pagination }} />
            </main> : <div className="centerOfParent">درحال بارگزاری ...</div>}
        </>
    );
};

export default Index;